<div class="container">
  <div [ngClass]="login.contraste ? 'card-panel mt-5 fundo-contraste' : 'card-panel mt-5 fundo-normal'">
    <form [formGroup]="entidadeForm" autocomplete="off" *ngIf="entidadeForm">
      <div class="row">
        <div class="col-md-8">
          <table>
            <td  style="vertical-align: middle;"><img src="assets/img/global/empenho.png" alt="pesquisa" title="" width="32" height="32"></td>
            <td>
              <p
                [ngClass]="this.login.contraste ? 'titulo-txt-contraste fonte-acessibilidade m-0' : 'titulo-txt-normal fonte-acessibilidade m-0'">
                {{titulo}}</p>
              <p
                [ngClass]="this.login.contraste ? 'subtitulo-txt-contraste fonte-acessibilidade m-0' : 'subtitulo-txt-normal fonte-acessibilidade m-0'">
                EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}</p>
            </td>
          </table>
        </div>
        <div class="col-md-4">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
          </button>
          <button (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Voltar a pesquisar" height="22" width="22">
            Voltar
          </button>
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-2'" />
      <div class="row">
        <div class="col-9">
          <label
            [ngClass]="this.login.contraste ? 'text-white font-weight-bold mr-2 fonte-acessibilidade' : 'text-primary font-weight-bold mr-2 fonte-acessibilidade'">
            EMPENHO Nº:
          </label>
          <label type="text" readonly id="numero_"
            [ngClass]="this.login.contraste ? 'text-white font-weight-bold mr-2 fonte-acessibilidade' : 'text-primary font-weight-bold mr-2 fonte-acessibilidade'">
            {{ ("00000" + entidadeForm.get('numero').value).slice(-5) }}
            <span *ngIf="entidade.valor_empenho < 0" class="ml-2 badge badge-danger">ANULAÇÃO</span>
          </label>
        </div>
        <div class="col-3" *ngIf="entidade.contrato">
          <div class="col-12">
            <div class="card border-white">
              <div class="card-body">
                <h6 class="card-title"><a class="text-black-50"
                    [routerLink]="['/transparencia/contratos', entidade.contrato.id]">Contrato Nº
                    {{entidade.contrato.numero}}</a></h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-2'" />
      <div class="row fonte-acessibilidade">
        <div class="col-md-12">
          <div class="row">
            <div class="form-group col-md-3">
              <label for="data_empenho">Data empenho</label>
              <input value="{{entidadeForm.get('data_empenho').value | date:'dd/MM/yyyy':'GMT'}}" type="text" disabled
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="data_empenho">
            </div>
            <div class="form-group col-md-3">
              <label for="compra">N˚ Compra</label>
              <span *ngIf="entidade.compra"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="compra" style="font-weight: bold">{{ ("00000" + entidade.compra.numero).slice(-5) }}</span>
            </div>
            <div *ngIf="entidade.valor_empenho >= 0" class="form-group col-md-3 pb-0 mb-0">
              <label for="valor_empenho" class="font-weight-bold">Valor empenhado</label>
              <input unmask="true" [imask]="imaskConfig" formControlName="valor_empenho" type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="valor_empenho" readonly placeholder="informe o valor"
                style="font-weight: bold; color: #1e88e5; font-size: 22px;">
            </div>
            <div *ngIf="entidade.valor_empenho < 0" class="form-group col-md-3 pb-0 mb-0">
              <label for="valor_empenho">Valor anulado</label>
              <input unmask="true" [imask]="imaskConfig" formControlName="valor_empenho" type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="valor_empenho" readonly placeholder="informe o valor"
                style="font-weight: bold; color: red; font-size: 22px;">
            </div>
            <div class="form-group col-md-3">

            </div>
          </div>
          <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-2'" />
          <div class="row">
            <div class="form-group col-md-3 pb-0 mb-0">
              <label for="especie">Espécie</label>
              <input value="{{loadEspecie()}}" type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="especie" disabled>
            </div>
            <div class="form-group col-md-3">
              <label for="processo">N˚ Processo</label>
              <input formControlName="processo" type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="processo">
            </div>
            <div class="form-group col-md-3">
              <label for="data_vencto">Previsão pagto</label>
              <input value="{{entidadeForm.get('data_vencimento').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                disabled
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="data_vencto">
            </div>
            <div class="form-group col-md-3" *ngIf="entidade.convenio">
              <div class="col-12">
                <div class="card border-white">
                  <div class="card-body">
                    <h6 class="card-title"><a class="text-black-50"
                        [routerLink]="['/transparencia/atas-registro-precos', entidade.contrato.id]">Ata Nº
                        {{entidade.ata.numero}}</a></h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-2'" />
      <div class="form-row fonte-acessibilidade">
        <div class="col-2">
          <label for="favorecido">CPF/CNPJ</label>
          <input *ngIf="entidade.favorecido" value="{{entidade.favorecido.cpf_cnpj | CPF}}" readonly disabled type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext font-weight-bold text-white' : 'form-control-plaintext font-weight-bold'"
            id="cpfnpj">
        </div>
        <div class="col-10">
          <label for="favorecido">Benefíciario</label>
          <input *ngIf="entidade.favorecido" value="{{entidade.favorecido.nome}}" readonly disabled type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext font-weight-bold text-white' : 'form-control-plaintext font-weight-bold'"
            id="favorecido">
        </div>
      </div>
      <div class="row fonte-acessibilidade">
        <div class="col-12">
          <input *ngIf="entidade.favorecido"
            value="{{entidade.favorecido.endereco}}, {{entidade.favorecido.num_endereco}}" readonly disabled type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'">
        </div>
      </div>
      <div class="row fonte-acessibilidade">
        <div class="col-12">
          <input *ngIf="entidade.favorecido" value="{{entidade.favorecido.municipio}}" readonly disabled type="text"
            class="form-control-plaintext">
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-2'" />
      <div class="form-group row fonte-acessibilidade">
        <label for="acao" class="col-sm-2 col-form-label">Ação governo:</label>
        <div class="col-sm-10">
          <input *ngIf="entidade.ficha" value="{{entidade.ficha.acao.codigo}} {{entidade.ficha.acao.nome}}" readonly
            disabled type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'" id="acao">
        </div>
      </div>
      <div class="form-group row fonte-acessibilidade">
        <label for="programa" class="col-sm-2 col-form-label">Programa:</label>
        <div class="col-sm-10">
          <input *ngIf="entidade.ficha" value="{{entidade.ficha.programa.codigo}} {{entidade.ficha.programa.nome}}"
            readonly disabled type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
            id="programa">
        </div>
      </div>
      <div class="form-group row fonte-acessibilidade">
        <label for="funcao" class="col-sm-2 col-form-label">Função:</label>
        <div class="col-sm-10">
          <input *ngIf="entidade.ficha" value="{{entidade.ficha.funcao.codigo}} {{entidade.ficha.funcao.nome}}" readonly
            disabled type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
            id="funcao">
        </div>
      </div>
      <div class="form-group row fonte-acessibilidade">
        <label for="subfuncao" class="col-sm-2 col-form-label">Subfunção:</label>
        <div class="col-sm-10">
          <input *ngIf="entidade.ficha" value="{{entidade.ficha.subfuncao.codigo}} {{entidade.ficha.subfuncao.nome}}"
            readonly disabled type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
            id="subfuncao">
        </div>
      </div>
      <div class="form-group row fonte-acessibilidade">
        <label for="recurso" class="col-sm-2 col-form-label">Recurso:</label>
        <div class="col-sm-10">
          <input *ngIf="entidade.ficha" value="{{entidade.ficha.recurso.codigo}} {{entidade.ficha.recurso.nome}}"
            readonly disabled type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
            id="recurso">
        </div>
      </div>
      <div class="form-group row fonte-acessibilidade">
        <label for="aplicacao" class="col-sm-2 col-form-label">Aplicação:</label>
        <div class="col-sm-10">
          <input *ngIf="entidade.ficha" value="{{entidade.ficha.aplicacao.codigo}} {{entidade.ficha.aplicacao.nome}}"
            readonly disabled type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
            id="aplicacao">
        </div>
      </div>
      <div class="form-group row fonte-acessibilidade">
        <label for="despesa" class="col-sm-2 col-form-label">Despesa:</label>
        <div class="col-sm-10">
          <input *ngIf="entidade.subelemento" value="{{entidade.subelemento.codigo}} {{entidade.subelemento.nome}}"
            readonly disabled type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext font-weight-bold text-white' : 'form-control-plaintext font-weight-bold'"
            id="despesa">
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-2'" />
      <div class="form-row fonte-acessibilidade">
        <div class="form-group col-12">
          <label for="historico">Histórico</label>
          <textarea formControlName="historico" readonly
            [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
            id="historico" rows="5"></textarea>
        </div>
      </div>

      <div class="form-row" *ngIf="listaCompras.length">
        <div class="col-12">
          <table
            [ngClass]="login.contraste ? 'table table-dark fonte-acessibilidade' : 'table table-eddy fonte-acessibilidade'">
            <thead>
              <tr style="height: 42px;">
                <th scope="col" class="text-right">Quantidade</th>
                <th scope="col" class="text-center">Unidade</th>
                <th scope="col" class="text-left">Descrição</th>
                <th scope="col" class="text-right">Valor Unitário</th>
                <th scope="col" class="text-right">Valor Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of listaCompras">
                <td style="width: 90px;" class="text-right">{{item.quantidade | number:'1.2-2'}}</td>
                <td style="width: 90px;" class="text-center">{{item.produto_unidade.unidade.nome}}</td>
                <td style="width: 50%;" class="text-left">{{item.produto_unidade.produto.nome}}</td>
                <td style="width: 110px;" class="text-right">{{item.valor_unitario | number:'1.2-2'}}</td>
                <td style="width: 110px;" class="text-right">{{item.valor_total | number:'1.2-2'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-2'" />
      <div class="row">
        <div class="col-12 mb-1" style="text-align: center;">
          <span
            [ngClass]="this.login.contraste ? 'font-weight-bold text-white fonte-acessibilidade' : 'font-weight-bold fonte-acessibilidade'">
            LIQUIDAÇÃO DO EMPENHO
          </span>
        </div>
      </div>
      <div class="row" *ngIf="!listaLiquidacoes.length">
        <div class="col-12 mb-1">
          <img src="assets/img/global/warning.png" alt="atencao" class="mb-1">
          <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-2'" />
          <span
            [ngClass]="this.login.contraste ? 'font-weight-bold text-white fonte-acessibilidade' : 'font-weight-bold text-black-50 fonte-acessibilidade'">
            NÃO HÁ LIQUIDAÇÕES EFETUADAS</span>
        </div>
      </div>

      <div class="form-row" *ngIf="listaLiquidacoes.length">
        <div class="col-12">
          <table
            [ngClass]="login.contraste ? 'table table-dark fonte-acessibilidade' : 'table table-eddy fonte-acessibilidade'">
            <thead>
              <tr style="height: 42px;">
                <th scope="col" class="text-center">Parcela</th>
                <th scope="col" class="text-center">Data Liquidação</th>
                <th scope="col" class="text-center">Data Vencimento</th>
                <th scope="col" class="text-left">Nº Documento</th>
                <th scope="col" class="text-center">Data Documento</th>
                <th scope="col" class="text-right">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of listaLiquidacoes">
                <td style="width: 80px;" class="text-center">
                  <span *ngIf="item.parcela > 0">{{item.parcela}}</span>
                  <span *ngIf="item.parcela === 0 && item.valor_liquidado >= 0" class="badge badge-primary">ÚNICA</span>
                  <span *ngIf="item.parcela === 0 && item.valor_liquidado < 0" class="badge badge-danger">ANULADO</span>
                </td>
                <td style="width: 90px;" class="text-center">{{item.data_liquidacao | date:'dd/MM/yyyy':'GMT'}}</td>
                <td style="width: 90px;" class="text-center">{{item.data_vencimento | date:'dd/MM/yyyy':'GMT'}}</td>
                <td style="width: 90px;" class="text-left">{{item.documento}}</td>
                <td style="width: 110px;" class="text-center">{{item.data_documento | date:'dd/MM/yyyy':'GMT'}}</td>
                <td style="width: 110px;" class="text-right">{{item.valor_liquidado | number:'1.2-2'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-2'" />
      <div class="row">
        <div class="col-12 mb-1" style="text-align: center;">
          <span
            [ngClass]="this.login.contraste ? 'font-weight-bold text-white fonte-acessibilidade' : 'font-weight-bold text-black-50 fonte-acessibilidade'">
            PAGAMENTO DO EMPENHO</span>
        </div>
      </div>
      <div class="row" *ngIf="!listaPagamentos.length">
        <div class="col-12 mb-1">
          <hr />
          <img src="assets/img/global/warning.png" alt="atencao" class="mb-1">
          <br />
          <span
            [ngClass]="this.login.contraste ? 'font-weight-bold text-white fonte-acessibilidade' : 'font-weight-bold text-black-50 fonte-acessibilidade'">
            NÃO HÁ PAGAMENTO EFETUADOS
          </span>
        </div>
      </div>
      <div class="form-row" *ngIf="listaPagamentos.length">
        <div class="col-12">
          <table
            [ngClass]="login.contraste ? 'table table-dark fonte-acessibilidade' : 'table table-eddy fonte-acessibilidade'">
            <thead>
              <tr style="height: 42px;">
                <th scope="col" class="text-center">Parcela</th>
                <th scope="col" class="text-center">Data Pagamento</th>
                <th scope="col" class="text-left">Nº Documento</th>
                <th scope="col" class="text-left">Conta bancária</th>
                <th scope="col" class="text-right">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of listaPagamentos">
                <td style="width: 80px;" class="text-center">
                  <span *ngIf="item.liquidacao.parcela > 0">{{item.liquidacao.parcela}}</span>
                  <span *ngIf="item.liquidacao.parcela === 0 && item.valor_pago >= 0"
                    class="badge badge-primary">ÚNICA</span>
                  <span *ngIf="item.liquidacao.parcela === 0 && item.valor_pago < 0"
                    class="badge badge-danger">ANULADO</span>
                </td>
                <td style="width: 90px;" class="text-center">{{item.data_pagamento | date:'dd/MM/yyyy':'GMT'}}</td>
                <td style="width: 90px;" class="text-left">{{item.documento}}</td>
                <td style="width: 40%;" class="text-left">{{item.conta.agencia}}
                  {{item.conta.numero_conta}}-{{item.conta.digito_conta}} {{item.conta.banco.nome}}</td>
                <td style="width: 110px;" class="text-right">{{item.valor_pago | number:'1.2-2'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br />
      <br />
      <div class="form-row">
        <div class="col-sm-12" *ngIf="entidade.contrato">
          <div class="card">
            <div class="card-header">
              Dados de contrato
            </div>
            <div class="card-body">
              <span>Número: {{entidade.contrato.numero}}</span><br />
              <span style="font-size: 12px">{{entidade.contrato.objeto}}</span><br />
              <table>
                <tr>
                  <td>Data Início:</td>
                  <td>{{entidade.contrato.data_inicio | date:'dd/MM/yyyy':'GMT'}}</td>
                </tr>
                <tr>
                  <td>Data Término:</td>
                  <td>{{entidade.contrato.data_termino | date:'dd/MM/yyyy':'GMT'}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-sm-12" *ngIf="entidade.convenio">
          <div class="card">
            <div class="card-header">
              Dados de convênio
            </div>
            <div class="card-body">
              <span>{{entidade.convenio.numero}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <pre *ngIf="entidadeForm">{{ entidadeForm | json}}</pre> -->
    </form>
  </div>
</div>
